import axios from "../axios-auth";
import orginal_axios from "axios";

export const chartOfAccountService = {
    getChartOfAccountList,
    getAllChartOfAccountList,
    saveChartOfAccount,
    getChartOfAccountDetail,
    exportAllChartOfAccount,
    templateDownload,
    saveExcel
};

function getChartOfAccountList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.accName) {
        params["accName"] = searchParams.accName;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.accountheadId) {
        params["accountheadId"] = searchParams.accountheadId;
    }
    if (searchParams.accountheadName) {
        params["accountheadName"] = searchParams.accountheadName;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.nature) {
        params["nature"] = searchParams.nature;
    }
    if (typeof(searchParams.isParent) === 'boolean') {
        params["isParent"] = searchParams.isParent;
    }
    if (typeof(searchParams.isExistParent) === 'boolean') {
        params["isExistParent"] = searchParams.isExistParent;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/chart-of-accounts", { params });
}

function getAllChartOfAccountList(searchParams) {
    
    let params = {
        
    };

    if (searchParams.accName) {
        params["accName"] = searchParams.accName;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.accountheadId) {
        params["accountheadId"] = searchParams.accountheadId;
    }
    if (searchParams.accountheadName) {
        params["accountheadName"] = searchParams.accountheadName;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.nature) {
        params["nature"] = searchParams.nature;
    }
    if (typeof (searchParams.isParent) === 'boolean') {
        params["isParent"] = searchParams.isParent;
    }
    if (typeof (searchParams.isExistParent) === 'boolean') {
        params["isExistParent"] = searchParams.isExistParent;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/print-chart-of-account", { params });
}

function saveChartOfAccount(chartOfAccount) {
    if (!chartOfAccount.id) {
        // new chartOfAccount
        return axios.post("/auth/chart-of-account", chartOfAccount);
    } else {
        // edit
        return axios.put("/auth/chart-of-account", chartOfAccount);
    }
}

function getChartOfAccountDetail(id) {
    return axios.get("/auth/chart-of-account/" + id);
}

function exportAllChartOfAccount(searchParams){
    let params={};
    if (searchParams.accName) {
        params["accName"] = searchParams.accName;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.accountheadId) {
        params["accountheadId"] = searchParams.accountheadId;
    }
    if (searchParams.accountheadName) {
        params["accountheadName"] = searchParams.accountheadName;
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }
    if (searchParams.nature) {
        params["nature"] = searchParams.nature;
    }
    if (typeof (searchParams.isParent) === 'boolean') {
        params["isParent"] = searchParams.isParent;
    }
    if (typeof (searchParams.isExistParent) === 'boolean') {
        params["isExistParent"] = searchParams.isExistParent;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/chart-of-account-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function templateDownload() {

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/chart-of-account-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveExcel(file) {
    return axios.post('/auth/register-chartofaccount-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}